import { EventRecord } from "@/shared/domain/events";

import { CreateDatasetEvent } from "./CreateDatasetEvent";
import { DeleteDatasetEvents } from "./DeleteDatasetEvents";

interface DatasetEventTableControlsProps {
  datasetId: string;
  resourceOwnerId: string;
  selectedEvents: EventRecord["event_id"][];
  onDeleteEvents: (events: EventRecord["event_id"][]) => void;
}

export function DatasetEventTableControls({
  datasetId,
  resourceOwnerId,
  selectedEvents,
  onDeleteEvents,
}: DatasetEventTableControlsProps) {
  return (
    <div style={{ display: "flex", gap: "0.5rem", marginBottom: "1rem" }}>
      <CreateDatasetEvent datasetId={datasetId} />
      <DeleteDatasetEvents
        datasetId={datasetId}
        resourceOwnerId={resourceOwnerId}
        selectedEvents={selectedEvents}
        onDeleteEvents={onDeleteEvents}
      />
    </div>
  );
}
